import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export type AppRole = "root" | "admin" | "user" | "maintenance";

export const useUserRole = () => {
  const { user } = useAuth();
  const [roles, setRoles] = useState<AppRole[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isActive = true;

    if (!user) {
      setRoles([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    const fetchRoles = async () => {
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id);

      if (!isActive) return;

      if (!error && data) {
        setRoles(data.map((r: any) => r.role as AppRole));
      } else {
        setRoles([]);
      }

      setLoading(false);
    };

    fetchRoles();

    return () => {
      isActive = false;
    };
  }, [user]);

  const isRoot = roles.includes("root");
  const isAdmin = isRoot || roles.includes("admin");
  const isMaintenance = roles.includes("maintenance");
  const canManage = isAdmin || isMaintenance;
  const canExport = isAdmin;

  return { roles, isRoot, isAdmin, isMaintenance, canManage, canExport, loading };
};
